<svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_92_455)">
<path d="M22.33 4.88875C22.33 4.39772 21.9323 4 21.4412 4H9.8875V12.8875H1V19.1088C1 19.5998 1.39772 19.9975 1.88875 19.9975H21.4412C21.9323 19.9975 22.33 19.5998 22.33 19.1088V4.88875Z" fill="#B41F30"/>
<path d="M22.33 5.77753H9.88749V7.55503H22.33V5.77753Z" fill="#E6E6E6"/>
<path d="M22.33 9.33252H9.88749V11.11H22.33V9.33252Z" fill="#E6E6E6"/>
<path d="M1 12.8875V14.665H22.33V12.8875H9.8875H1Z" fill="#E6E6E6"/>
<path d="M22.33 16.4425H1V18.22H22.33V16.4425Z" fill="#E6E6E6"/>
<path d="M9.8875 12.8875H1V4.88875C1 4.39772 1.39772 4 1.88875 4H9.8875V12.8875Z" fill="#00256A"/>
<path d="M5.44375 7.52032L5.16246 8.12823H4.49412L4.98293 8.63482L4.80252 9.36715L5.44375 9.00365L6.08498 9.36715L5.90457 8.63482L6.39338 8.12823H5.72415L5.44375 7.52032Z" fill="white"/>
<path d="M3.26943 5.34601L2.98858 5.95391H2.32024L2.80861 6.4605L2.6282 7.19283L3.26943 6.82933L3.91111 7.19283L3.73025 6.4605L4.21906 5.95391H3.54983L3.26943 5.34601Z" fill="white"/>
<path d="M7.61807 5.34601L7.89892 5.95391H8.56726L8.07889 6.4605L8.25931 7.19283L7.61807 6.82933L6.9764 7.19283L7.15726 6.4605L6.66845 5.95391H7.33767L7.61807 5.34601Z" fill="white"/>
<path d="M3.26943 11.5414L2.98858 10.9335H2.32024L2.80861 10.4269L2.6282 9.69458L3.26943 10.0581L3.91111 9.69458L3.73025 10.4269L4.21906 10.9335H3.54983L3.26943 11.5414Z" fill="white"/>
<path d="M7.61807 11.5414L7.89892 10.9335H8.56726L8.07889 10.4269L8.25931 9.69458L7.61807 10.0581L6.9764 9.69458L7.15726 10.4269L6.66845 10.9335H7.33767L7.61807 11.5414Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_92_455">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
